import { z } from 'zod';
import { Validation } from '@mews/framework';

export const CENTRAL_RATE_GROUP_ID_FIELD_NAME = 'centralRateGroupId';

export const validationSchema = z.object({
    [CENTRAL_RATE_GROUP_ID_FIELD_NAME]: Validation.String.Required,
});

export type FormValues = z.infer<typeof validationSchema>;
